export const GLOBAL_MAX_LETTERS = 15;
export const MAX_GUESSES = 6;
export const GLOBAL_MIN_LETTERS = 3;
